const prefix = 'pm-alt-text';

export const ClassNames = {
	FLOATING_TOOLBAR_COMPONENT: `${prefix}-alt-text-floating-toolbar`,
	MEDIA_CONTAINER: 'mediaView-content-wrap',
};
